export default "__VITE_ASSET__D1lszcV6__"